<template>
<div style="overflow: auto;">
	<div class="sel">
		<p>校区：<el-select clearable @change="getname" size="small" v-model="sel.sch" placeholder="请选择"><el-option v-for="item in datapower.sch" :key="'sch'+item.id" :label="item.name" :value="item.id"></el-option></el-select></p>
		<p>职务：<el-select clearable @change="getname" size="small" v-model="sel.job" placeholder="请选择"><el-option v-for="item in datapower.job" :key="'job'+item.id" :label="item.name" :value="item.id"></el-option></el-select></p>
		<p>科目：<el-select clearable @change="getname" size="small" v-model="sel.sub" placeholder="请选择"><el-option v-for="item in datapower.sub" :key="'sub'+item.id" :label="item.nj+item.sub" :value="item.id"></el-option></el-select></p>
		<p>等级：<el-select clearable @change="getname" size="small" v-model="sel.dj" placeholder="请选择"><el-option v-for="item in datapower.dj" :key="'dj'+item.id" :label="item.dj1+item.dj2" :value="item.id"></el-option></el-select></p>
		<p>姓名：<el-select clearable size="small" v-model="sel.name" placeholder="请选择"><el-option v-for="item in name" :key="'name'+item.id" :label="item.name" :value="item.id"></el-option></el-select></p>
		<p>状态：<el-select @change="getname" size="small" v-model="sel.onjob" placeholder="请选择"><el-option key="onjob1" label="在职" :value="true"></el-option><el-option key="onjob2" label="离职" :value="false"></el-option></el-select></p>
		<p><el-button type="primary" @click="getdate(1)" size="small">查询</el-button><el-button type="info" @click="reset" size="small">重置</el-button></p>
	</div>
	<div class="m10 bg-f br10 p10" >
		<!-- 表哥 -->
		<el-table stripe :data="userlist" :height="this.getsize.height - 260 - (this.getsize.width<1340 ? 42:0)" style="width: 100%;margin-bottom: 10px;max-width: 1180px;">
			<el-table-column  prop="name" label="姓名" width="100" fixed="left"></el-table-column>
			<el-table-column  prop="tell" label="电话" width="130"></el-table-column>
			<el-table-column  prop="sch" label="校区" width="100"></el-table-column>
			<el-table-column  prop="job" label="职务" width="100"></el-table-column>
			<el-table-column  prop="sub" label="主要科目" width="100"></el-table-column>
			<el-table-column  prop="dj" label="等级" width="100"></el-table-column>
			<el-table-column  prop="djday" label="评定日期" width="110"></el-table-column>
			<el-table-column  prop="inday" label="入职日期" width="110"></el-table-column>
			<el-table-column  prop="outday" label="离职日期" width="110"></el-table-column>
			<el-table-column  label="操作" width="220" fixed="right">
				<template slot-scope="scope" v-if="scope.row.id!==1">
					<el-button v-if="power.userinf" @click="showinf(scope.$index)" type="success" size="mini">详细<br>信息</el-button>
					<el-button v-if="power.oldinf" @click="oldinf(scope.$index)" type="success" size="mini">历史<br>信息</el-button>
					<el-dropdown v-if="power.ismore&&ismore" style="margin-left: 10px;" @command="(e)=>{morehandle[e](scope.$index)}">
						<el-button type="primary" size="mini">更多<br>操作</el-button>
						<el-dropdown-menu>
							<el-dropdown-item v-if="power.repinf" command="repinf">修改信息</el-dropdown-item>
							<el-dropdown-item v-if="power.repsch" command="repsch">校区变更</el-dropdown-item>
							<el-dropdown-item v-if="power.repjob" command="repjob">职务变更</el-dropdown-item>
							<el-dropdown-item v-if="power.repsub" command="repsub">科目变更</el-dropdown-item>
							<el-dropdown-item v-if="power.repdj" command="repdj">等级评定</el-dropdown-item>
							<el-dropdown-item v-if="power.reppwd" command="reppassword">密码重置</el-dropdown-item>
							<el-dropdown-item v-if="power.setout" command="setout">办理离职</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination background @size-change="sizechange" @current-change="choosepage" :current-page.sync="page.nowpage" :page-size="page.onenum" layout="prev, pager, next,sizes,total" :total="page.total" :page-sizes="[20,50,100]"></el-pagination>
	</div>
	<user-inf :user="oneuser" :show="drawer.inf" @close="drawer.inf=false"></user-inf>
	<old-inf :user="oneuser" :show="drawer.oldinf" @close="drawer.oldinf=false"></old-inf>
	<rep-inf :user="oneuser" :show="drawer.repinf" @close="infreped"></rep-inf>
	<rep-sch :user="oneuser" :show="drawer.repsch" :sch="datapower.sch" @close="schreped"></rep-sch>
	<rep-job :user="oneuser" :show="drawer.repjob" :job="datapower.job" @close="jobreped"></rep-job>
	<rep-sub :user="oneuser" :show="drawer.repsub" :sub="datapower.sub" @close="subreped"></rep-sub>
	<rep-dj :user="oneuser" :show="drawer.repdj" :dj="datapower.dj" @close="djreped"></rep-dj>
	<set-out :user="oneuser" :show="drawer.setout" @close="setouted"></set-out>
</div>
</template>

<script>
import { mapGetters,mapMutations } from 'vuex'
import UserInf from "./userinf.vue";
import OldInf from "./oldinf.vue"
import RepInf from "./repinf.vue"
import RepSch from "./repsch.vue"
import RepJob from "./repjob.vue"
import RepSub from "./repsub.vue"
import RepDj from "./repdj.vue"
import SetOut from "./setout.vue"
export default{
	name:'addtch',
	data() {
		return {
			page:{},
			sel:{},
			ismore:true,
			power:{},
			users:[],
			name:[],
			drawer:{
				inf:false,oldinf:false,repinf:false,repsch:false,repjob:false,repsub:false,repdj:false,setout:false
			},
			oneuser:{
				userid:-1
			},
			morehandle:{
				repinf:(e)=>{
					if(!this.power.repinf){
						this.myfun.messageErr(`您没有"修改信息"的权限`)
						return
					} 
					this.oneuser=this.users[e]
					this.drawer.repinf=true
				},
				repsch:(e)=>{
					if(!this.power.repsch){
						this.myfun.messageErr(`您没有"校区变更"的权限`)
						return
					} 
					this.oneuser=this.users[e]
					this.drawer.repsch=true
				},
				repjob:(e)=>{
					if(!this.power.repjob){
						this.myfun.messageErr(`您没有"职务变更"的权限`)
						return
					} 
					this.oneuser=this.users[e]
					this.drawer.repjob=true
				},
				repsub:(e)=>{
					if(!this.power.repsub){
						this.myfun.messageErr(`您没有"科目变更"的权限`)
						return
					} 
					this.oneuser=this.users[e]
					this.drawer.repsub=true
				},
				repdj:(e)=>{
					if(!this.power.repdj){
						this.myfun.messageErr(`您没有"等级评定"的权限`)
						return
					} 
					this.oneuser=this.users[e]
					this.drawer.repdj=true
				},
				reppassword:(e)=>{
					if(!this.power.reppwd){
						this.myfun.messageErr(`您没有"密码重置"的权限`)
						return
					} 
					this.myfun.myfloat("密码重置",`确定重置<span style="color:#f00">${this.users[e].name}</span>的密码`,(close)=>{
						//提交服务器
						this.myfun.Loading()
						const formdata = new FormData()
						formdata.append("userid",this.users[e].id)
						this.axios.post("data:resetpwd",formdata).then(e=>{
							this.myfun.Loadingclose()
							close()
							if(!e)return
							this.myfun.messageSuc("密码重置成功")
						})
					},"取消密码重置")
				},
				setout:(e)=>{
					if(!this.power.setout){
						this.myfun.messageErr(`您没有"办理离职"的权限`)
						return
					} 
					this.oneuser=this.users[e]
					this.drawer.setout=true
				},
			}
		}
	},
	components:{
		UserInf,OldInf,RepInf,RepSch,RepJob,RepSub,RepDj,SetOut
	},
	computed:{
		...mapGetters(['getsize']),
		...mapGetters('User',["getPagePower","getDataPower","getuser"]),
		datapower(){
			return this.getDataPower("教师列表")
		},
		userlist(){
			return this.users.map(e=>{
				return {
					id:e.id,
					name:e.name,
					tell:e.tell,
					sch:e.sch.map(s=>{return s.name}).join("/"),
					job:e.job.map(j=>{return j.name}).join("/"),
					sub:e.sub.nj+e.sub.sub,
					dj:e.dj.dj1+e.dj.dj2,
					djday:e.dj.stime,
					inday:e.stime,
					outday:e.etime
				}
			})
		}
	},
	methods:{
		...mapMutations('Tabs',['setCache']),
		...mapGetters('Tabs',['getCache']),
		getpower(){
			let obj={
				userinf:this.getPagePower("信息管理/教师列表/详细信息"),
				oldinf:this.getPagePower("信息管理/教师列表/历史信息"),
				repinf:this.getPagePower("信息管理/教师列表/修改信息"),
				repsch:this.getPagePower("信息管理/教师列表/校区变更"),
				repjob:this.getPagePower("信息管理/教师列表/职务变更"),
				repsub:this.getPagePower("信息管理/教师列表/科目变更"),
				repdj:this.getPagePower("信息管理/教师列表/等级评定"),
				reppwd:this.getPagePower("信息管理/教师列表/密码重置"),
				setout:this.getPagePower("信息管理/教师列表/办理离职"),
				ismore:false
			}
			if(obj.repinf||obj.repsch||obj.repjob||obj.repsub||obj.repdj||obj.reppwd||obj.setout){
				obj.ismore=true
			}
			this.power=obj
		},
		//页码操作
		sizechange(e){
			//每页显示条数变化时
			this.page.onenum=e
			this.getdate(1)
		},
		choosepage(e){
			//页码改变时
			this.getdate(e)
		},
		seldata(){
			let obj={
				sch:this.sel.sch?this.sel.sch:-1,
				job:this.sel.job?this.sel.job:-1,
				sub:this.sel.sub?this.sel.sub:-1,
				dj:this.sel.dj?this.sel.dj:-1,
				name:this.sel.name?this.sel.name:-1,
				onjob:-1,
			}
			if(this.sel.onjob===true){
				obj.onjob=2
			}
			if(this.sel.onjob===false){
				obj.onjob=1
			}
			return obj
		},
		//页面数据
		getdate(page){
			//获取页面数据
			this.myfun.Loading()
			const formdata = new FormData()
			formdata.append('sel',JSON.stringify(this.seldata()))
			formdata.append("page",JSON.stringify({onenum:this.page.onenum,nowpage:page}))
			this.axios.post("data:gettchlist",formdata).then(e=>{
				this.myfun.Loadingclose()
				if(!e)return
				this.ismore=this.sel.onjob
				this.users=e.list
				this.page=e.page
			})
		},
		//筛选操作
		reset(){
			this.sel={sch:"",job:"",sub:"",dj:"",name:"",onjob:true}
			this.name=[]
			if(this.datapower.dp==="校区"){
				this.sel.sch=this.getuser.sch[0].id
				this.getname()
				return
			}
			if(this.datapower.dp=="个人"){
				this.sel.sch=this.getuser.sch[0].id
				this.name=[{id:this.getuser.id,name:this.getuser.name}]
				this.sel.name=this.name[0].id
				return
			}
			
		},
		getname(){
			if(this.datapower.dp=="个人"){
				this.name=[{id:this.getuser.id,name:this.getuser.name}]
				this.sel.name=this.name[0].id
				return
			}
			if(this.sel.sch===""&&this.sel.job===""&&this.sel.sub===""&&this.sel.dj===""){
				this.name=[]
				this.sel.name=""
				return
			}
			//访问服务器获取名单
			this.myfun.Loading()
			const formdata = new FormData()
			formdata.append("page","信息管理/教师列表")
			formdata.append('sel',JSON.stringify(this.seldata()))
			this.axios.post("data:getname",formdata).then(e=>{
				this.myfun.Loadingclose()
				if(!e)return
				this.name=e
				this.sel.name=""
			})
		},
		//数据操作
		showinf(e){
			if(!this.power.userinf){
				this.myfun.messageErr(`您没有"详细信息"的权限`)
				return
			} 
			this.oneuser=this.users[e]
			this.drawer.inf=true
		},
		oldinf(e){
			if(!this.power.oldinf){
				this.myfun.messageErr(`您没有"历史信息"的权限`)
				return
			} 
			this.oneuser=this.users[e]
			this.drawer.oldinf=true
		},
		infreped(e){
			this.drawer.repinf=false
			if(e.isrep){
				this.oneuser.stime=e.data.stime
				this.oneuser.sch=e.data.sch
				this.oneuser.job=e.data.job
				this.oneuser.dj=e.data.dj
				this.oneuser.sub=e.data.sub
			}
		},
		schreped(e){
			this.drawer.repsch=false
			if(e.isrep){
				this.oneuser.sch=e.data
			}
		},
		jobreped(e){
			this.drawer.repjob=false
			if(e.isrep){
				this.oneuser.job=e.data
			}
		},
		subreped(e){
			this.drawer.repsub=false
			if(e.isrep){
				this.oneuser.sub=e.data
			}
		},
		djreped(e){
			this.drawer.repdj=false
			if(e.isrep){
				this.oneuser.dj=e.data
			}
		},
		setouted(e){
			this.drawer.setout=false
			if(e.isrep){
				this.getdate(this.page.nowpage)
			}
		}
	},
	created(){
		if(!this.getPagePower("信息管理/教师列表")){
			this.myfun.messageErr(`您没有"教师列表"的权限`)
			this.$router.push("/404")
			return
		} 
		//判断是否有缓存数据，有则调取缓存，没有则初始化
		const cache=this.getCache()('tchlist')
		if(cache){
			this.page=cache.page
			this.sel=cache.sel
			this.name=cache.name
			this.users=cache.users
			this.power=cache.power
		}else{
			this.page={total:1000,onenum:20,nowpage:1}
			this.reset()
			this.getdate(1)
			this.getpower()
		}
	},
	beforeDestroy(){
		//卸载前，保存缓存数据，关闭窗口则不缓存
		this.setCache({
			label:'tchlist',
			page:this.page,
			sel:this.sel,
			users:this.users,
			name:this.name,
			power:this.power,
		})
		
	}
}
</script>

<style scoped>
</style>
